import { render, staticRenderFns } from "./ChatManage.vue?vue&type=template&id=e3a44328&scoped=true&"
import script from "./ChatManage.vue?vue&type=script&lang=js&"
export * from "./ChatManage.vue?vue&type=script&lang=js&"
import style0 from "./ChatManage.vue?vue&type=style&index=0&id=e3a44328&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3a44328",
  null
  
)

export default component.exports